import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader, Section } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE, IF_ANY } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page} 
        subheading=""
        > Create Login</PageHeader>

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMAccountCreateLogin} label="✨ Enhance with AI" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement,"1")}/>
        <TextRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.LLMAccountCreateLogin,"1")}>
            <div className="rainbowPower">
            Your AI assistant will enhance the answer below using contextual data from the customer’s profile, conversation history, and your knowledge graph.
            </div>
        </TextRow>
        
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.AccountCreateLogin1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.AccountCreateLogin2}
            enableSwitchVar={LocationVarKey.AccountCreateLogin2Enabled}
        />

        <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow {...page}  keyName= {LocationVarKey.AfterNavigateAccountLoginCreateLogin} label="Ask if they want to be navigated to your Account Login URL"/>
        <Section {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}>
        <SectionHeader {...page}  subheading="After navigating the customer to a new page, the chat will open and respond based on the information below." hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin,"1")} > After Navigate </SectionHeader>
        <TextAreaRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin,"1")} 
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.AfterNavigateAccountLoginCreateLogin1}
        />
        <TextAreaRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin,"1")} 
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.AfterNavigateAccountLoginCreateLogin2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginCreateLogin2Enabled}
        />
        </Section>
        </Section>
    </>
}